import React from "react";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import "./Order_Process.css";
import Vertical_Tracker from "../Common-Component/Vertical_Tracker/Vertical_Tracker";
import Order_Process_Cart from "./Order_Process_Cart/Order_Process_Cart";
import Confirm_Add_to_Cart from "./Confirm_Add_to_Cart/Confirm_Add_to_Cart";
import { useLocation } from "react-router-dom";
function Order_Process() {
  const breadcrumbData = [
    { name: "Visiting Cards", link: "/visiting-cards" },
    { name: "Standard Visiting Cards", link: "/product-details-page" },
    { name: "Confirm & Add to Cart" },
  ];

  const stepList = [
    "Customise Business Cards",
    "Design Business Card",
    "Confirm & Add to Cart",
    "Cart",
    "Order Review",
  ];

  const location = useLocation();
  const data = location.state || {};

 
  
  return (
    <>
      <section className="Order_Process">
        <div className="custom_container">
          <div className="breadcrump_holder">
            <div className="Breadcrumb_div">
              <Breadcrumb_comp data={breadcrumbData} />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4">
              <Vertical_Tracker steps={stepList.map((label) => ({ label }))} />
            </div>
            <div className="col-lg-9 col-md-8">
              <Confirm_Add_to_Cart data={data}/>
              {/* <Order_Process_Cart/> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_Process;
